import QuestionnaireRecord from "./Questionnaire/record";

export AchievementRecord from '../entities/Achievement/record';
export AgreementRecord from '../entities/Agreement/record';
export ApiUserRecord from '../entities/ApiUser/record';
export AvailableDateRecord from '../entities/AvailableDate/record';
export AvailableDateSettingRecord from '../entities/AvailableDateSetting/record';
export AreaRecord from '../entities/Area/record';
export BasicSchemaItemRecord from '../entities/BasicSchemaItem/record';
export BasicSchemaRecord from '../entities/BasicSchema/record';
export BookingInvoiceItemAttestedDateRecord from '../entities/BookingInvoiceItemAttestedDate/record';
export BookingInvoiceItemBookedDateRecord from '../entities/BookingInvoiceItemBookedDate/record';
export BookingInvoiceItemRecord from '../entities/BookingInvoiceItem/record';
export BookingPaymentItemAttestedDateRecord from '../entities/BookingPaymentItemAttestedDate/record';
export BookingPaymentItemBookedDateRecord from '../entities/BookingPaymentItemBookedDate/record';
export BookingPaymentItemRecord from '../entities/BookingPaymentItem/record';
export BookingRecord from '../entities/Booking/record';
export BookingResourceRecord from '../entities/BookingResource/record';
export BudgetRecord from '../entities/Budget/record';
export CompetencyRecord from '../entities/Competency/record';
export ContactRecord from '../entities/Contact/record';
export Coordinate from '../entities/Coordinate/record';
export CustomerAgreementInvoiceSettingRecord from '../entities/CustomerAgreementInvoiceSetting/record';
export CustomerAttestRecord from '../entities/CustomerAttest/record';
export CustomerAttestResourceRecord from '../entities/CustomerAttestResource/record';
export CustomerBjornLundenSettingRecord from '../entities/CustomerBjornLundenSetting/record';
export CustomerFortnoxSettingRecord from '../entities/CustomerFortnoxSetting/record';
export CustomerListRecord from '../entities/CustomerList/record';
export CustomerRecord from '../entities/Customer/record';
export DayRecord from '../entities/Day/record';
export DocumentTemplateRecord from '../entities/DocumentTemplate/record';
export DomainRecord from '../entities/Domain/record';
export EmailRecord from '../entities/Email/record';
export EmploymentContractPreviewRecord from '../entities/EmploymentContractPreview/record';
export EmploymentContractRecord from '../entities/EmploymentContract/record';
export EmploymentNumberRecord from '../entities/EmploymentNumber/record';
export EntityViewRecord from '../entities/EntityView/record';
export EventRecord from '../entities/Event/record';
export ExpenseRecord from '../entities/Expense/record';
export FileRecord from '../entities/File/record';
export GeoCodeRecord from '../entities/GeoCode/record';
export HolidayRecord from '../entities/Holiday/record';
export InquiryRecord from '../entities/Inquiry/record';
export InternalTimeReport from '../entities/InternalTimeReport/record';
export InvoiceAddressRecord from '../entities/InvoiceAddress/record';
export InvoiceDeliveryTypeRecord from '../entities/InvoiceDeliveryType/record';
export InvoiceDetailRecord from '../entities/InvoiceDetail/record';
export InvoiceRecord from '../entities/Invoice/record';
export ItemsRecord from '../entities/Items/record';
export JobBoardRecord from '../entities/JobBoard/record';
export MileageAllowanceRecord from '../entities/MileageAllowance/record';
export MunicipalityRecord from '../entities/Municipality/record';
export OccupationNameRecord from '../entities/OccupationName/record';
export OneflowCollectionRecord from '../entities/OneflowCollection/record';
export OneflowTemplateRecord from '../entities/OneflowTemplate/record';
export PaymentCollectionRecord from '../entities/PaymentCollection/record';
export PaymentRecord from '../entities/Payment/record';
export PaymentRowRecord from '../entities/PaymentRow/record';
export PersonRecord from '../entities/Person/record';
export PreviewBookingSmsRecord from '../entities/PreviewBookingSms/record';
export PricePeriodRecord from '../entities/PricePeriod/record';
export QualifyingDeductionRecord from '../entities/QualifyingDeduction/record';
export QuestionnaireRecord from '../entities/Questionnaire/record';
export RecruitmentAdApplicationRecord from '../entities/RecruitmentAdApplication/record';
export RecruitmentAdContactRecord from '../entities/RecruitmentAdContact/record';
export RecruitmentAdRecord from '../entities/RecruitmentAd/record';
export RecruitmentStatusRecord from '../entities/RecruitmentStatus/record';
export ReplacementModelPeriodDeviationRecord from '../entities/ReplacementModelPeriodDeviation/record';
export ReplacementModelPeriodRecord from '../entities/ReplacementModelPeriod/record';
export ReplacementModelRecord from '../entities/ReplacementModel/record';
export ResourceFortnoxSettingRecord from '../entities/ResourceFortnoxSetting/record';
export ResourceListRecord from '../entities/ResourceList/record';
export ResourceRecord from '../entities/Resource/record';
export ServiceRecord from '../entities/Service/record';
export SignableDocumentRecord from '../entities/SignableDocument/record';
export PushNotificationRecord from '../entities/PushNotification/record';
export SmsRecord from '../entities/Sms/record';
export StaffingCompanyGroupRecord from '../entities/StaffingCompanyGroup/record';
export StaffingCompanyGroupUsageRecord from '../entities/StaffingCompanyGroupUsage/record';
export StaffingCompanyRecord from '../entities/StaffingCompany/record';
export StatisticRecord from '../entities/Statistic/record';
export TaskRecord from '../entities/Task/record';
export TermRecord from '../entities/Term/record';
export TimeplanPeriodRecord from '../entities/TimeplanPeriod/record';
export TimeplanUnitRecord from '../entities/TimeplanUnit/record';
export TimeReportRecord from '../entities/TimeReport/record';
export UserRecord from '../entities/User/record';
export WeeklyBookingRecord from '../entities/WeeklyBooking/record';
export WeeklyTimeReportSummaryRecord from '../entities/WeeklyTimeReportSummary/record';
export WorkTypeRecord from '../entities/WorkType/record';
